import { Job } from "Models/job";

export const isNullOrEmpty = (value: any): boolean => {
  if (!value) return true;
  if (Array.isArray(value)) {
    return value.length === 0 || value.every((item) => isNullOrEmpty(item));
  }

  if (typeof value === "object") {
    return Object.keys(value).length === 0;
  }

  return false;
};
